// i18n/Insight.js

export const heroInsightText = {
  en: {
    small: "Business Research",
    main: "Insights",
  },
  vi: {
    small: "Thông tin & ",
    main: "Xu hướng",
  },
};

export const insightData = {
  en: [
    {
      id: 1,
      title: "Government & SME Insights",
      description:
        "Stay informed with trusted government and SME-focused platforms that provide valuable insights into business growth, workforce trends, digital transformation, grants, leadership development, and economic opportunities across New Zealand and Australia.",

      sections: [
        {
          country: "New Zealand",

          items: [
            {
              title: "MBIE (Ministry of Business, Innovation & Employment)",
              description:
                "SME trends, workforce development, skills shortages, digital transformation, and economic reports.",
              link: "https://www.mbie.govt.nz/business-and-employment/employment-and-skills/employment-legislation-reviews",
              image: "/maria/insight/mbie.png",
              embed: false,
            },

            {
              title: "New Zealand Trade & Enterprise (NZTE)",
              description:
                "Business growth, export opportunities, capability training, and SME support programmes.",
              link: "https://www.nzte.govt.nz",
              image: "/maria/insight/NZTE.png",
              embed: false,
            },

            {
              title: "Business.govt.nz",
              description:
                "Insights into challenges New Zealand SMEs face and the support services they require.",
              link: "https://www.business.govt.nz",
              image: "/maria/insight/business.png",
              embed: false,
            },
          ],
        },

        {
          country: "Australia",

          items: [
            {
              title: "Austrade",
              description:
                "Industry growth sectors, SME support, and international business opportunities in Australia.",
              link: "https://www.austrade.gov.au",
              image: "/maria/insight/AUS-business.png",
              embed: false,
            },

            {
              title: "Business.gov.au",
              description:
                "Small business trends, grants, AI adoption, leadership training, and advisory opportunities.",
              link: "https://business.gov.au",
              image: "/maria/insight/aus-gov.png",
              embed: false,
            },
          ],
        },
      ],
    },

    {
      id: 2,
      title: "Training & Coaching Industry Associations",

      description:
        "Understand industry standards, leadership development trends, coaching demand, and workplace capability needs through leading professional associations in New Zealand and Australia.",

      sections: [
        {
          country: "New Zealand",

          items: [
            {
              title: "Human Resources New Zealand (HRNZ)",
              description:
                "Corporate training needs, HR capability gaps, and workforce trends.",
              link: "https://www.hrnz.org.nz",
              image: "/maria/insight/HRNZ.png",
              embed: false,
            },

            {
              title:
                "New Zealand Institute of Management and Leadership (NZIM)",
              description:
                "Leadership development and management training opportunities.",
              link: "https://www.nzim.co.nz",
            },
          ],
        },

        {
          country: "Australia",

          items: [
            {
              title:
                "Institute of Managers and Leaders Australia & New Zealand",

              description:
                "Executive coaching, management capability, and leadership trends.",

              link: "https://www.managersandleaders.com.au",
            },

            {
              title: "Australian Institute of Training and Development (AITD)",

              description:
                "Learning & development, workplace training, instructional design, and HR training insights.",

              link: "https://www.aitd.com.au",
            },

            {
              title: "International Coaching Federation Australasia",

              description:
                "Coaching industry standards, events, and coaching demand trends.",

              link: "https://www.icfaustralasia.com/",
              image: "/maria/insight/aus-icf.png",
              embed: false,
            },
          ],
        },
      ],
    },

    {
      id: 3,
      title: "Market Research & Trend Platforms",

      description:
        "Access market intelligence and emerging trends to understand what businesses and professionals are actively seeking in areas such as AI, coaching, consulting, online learning, and SME growth.",

      sections: [
        {
          country: "Global Platforms",

          items: [
            {
              title: "IBISWorld Australia & New Zealand",
              description:
                "Industry reports covering consulting, coaching, business advisory, digital training, education, and SMEs.",
              link: "https://www.ibisworld.com",
            },

            {
              title: "Statista",
              description:
                "Global and regional statistics on online learning, AI adoption, coaching, and SME spending trends.",
              link: "https://www.statista.com/",
              image: "/maria/insight/statista.png",
              embed: false,
            },

            {
              title: "LinkedIn Business Insights",
              description:
                "Skill demand, hiring trends, workforce insights, and emerging business pain points.",
              link: "https://business.linkedin.com",
              image: "/maria/insight/linkedin.png",
              embed: false,
            },
          ],
        },
      ],
    },
  ],

  vi: [
    {
      id: 1,
      title: "Thông Tin Chính Phủ & Doanh Nghiệp SME",

      description:
        "Cập nhật thông tin từ các nền tảng uy tín của chính phủ và doanh nghiệp SME nhằm nắm bắt xu hướng tăng trưởng, chuyển đổi số, phát triển nguồn nhân lực, hỗ trợ tài chính và cơ hội kinh doanh tại New Zealand và Australia.",

      sections: [
        {
          country: "New Zealand",

          items: [
            {
              title: "MBIE (Bộ Kinh Doanh, Đổi Mới & Việc Làm New Zealand)",

              description:
                "Xu hướng SME, phát triển lực lượng lao động, thiếu hụt kỹ năng, chuyển đổi số và báo cáo kinh tế.",

              link: "https://www.mbie.govt.nz",
              image: "/maria/insight/mbie.png",
              embed: false,
            },

            {
              title: "New Zealand Trade & Enterprise (NZTE)",

              description:
                "Tăng trưởng doanh nghiệp, cơ hội xuất khẩu, đào tạo năng lực và chương trình hỗ trợ SME.",

              link: "https://www.nzte.govt.nz",
              image: "/maria/insight/NZTE.png",
              embed: false,
            },

            {
              title: "Business.govt.nz",

              description:
                "Thông tin về những khó khăn của doanh nghiệp SME tại New Zealand và các dịch vụ hỗ trợ cần thiết.",

              link: "https://www.business.govt.nz",
              image: "/maria/insight/business.png",
              embed: false,
            },
          ],
        },

        {
          country: "Australia",

          items: [
            {
              title: "Austrade",

              description:
                "Xu hướng ngành tăng trưởng, hỗ trợ SME và cơ hội kinh doanh quốc tế tại Australia.",

              link: "https://www.austrade.gov.au",
              image: "/maria/insight/AUS-business.png",
              embed: false,
            },

            {
              title: "Business.gov.au",

              description:
                "Xu hướng doanh nghiệp nhỏ, chương trình hỗ trợ, ứng dụng AI, đào tạo lãnh đạo và tư vấn doanh nghiệp.",

              link: "https://business.gov.au",
              image: "/maria/insight/aus-gov.png",
              embed: false,
            },
          ],
        },
      ],
    },

    {
      id: 2,
      title: "Hiệp Hội Đào Tạo & Coaching",

      description:
        "Nắm bắt tiêu chuẩn ngành, xu hướng phát triển lãnh đạo, nhu cầu coaching và năng lực nhân sự thông qua các hiệp hội chuyên nghiệp hàng đầu tại New Zealand và Australia.",

      sections: [
        {
          country: "New Zealand",

          items: [
            {
              title: "Human Resources New Zealand (HRNZ)",

              description:
                "Nhu cầu đào tạo doanh nghiệp, khoảng trống năng lực nhân sự và xu hướng lực lượng lao động.",

              link: "https://www.hrnz.org.nz",
              image: "/maria/insight/HRNZ.png",
              embed: false,
            },

            {
              title:
                "New Zealand Institute of Management and Leadership (NZIM)",

              description: "Xu hướng đào tạo quản lý và phát triển lãnh đạo.",

              link: "https://www.nzim.co.nz",
            },
          ],
        },

        {
          country: "Australia",

          items: [
            {
              title:
                "Institute of Managers and Leaders Australia & New Zealand",

              description:
                "Coaching điều hành, năng lực quản lý và xu hướng lãnh đạo.",

              link: "https://www.managersandleaders.com.au",
            },

            {
              title: "Australian Institute of Training and Development (AITD)",

              description:
                "Đào tạo doanh nghiệp, học tập & phát triển, thiết kế đào tạo và HR training.",

              link: "https://www.aitd.com.au",
            },

            {
              title: "International Coaching Federation Australasia",

              description:
                "Tiêu chuẩn ngành coaching, sự kiện và xu hướng nhu cầu coaching.",

              link: "https://www.icfaustralasia.com/",
              image: "/maria/insight/aus-icf.png",
              embed: false,
            },
          ],
        },
      ],
    },

    {
      id: 3,
      title: "Nền Tảng Nghiên Cứu Thị Trường & Xu Hướng",

      description:
        "Tiếp cận dữ liệu nghiên cứu thị trường và xu hướng mới nhất để hiểu doanh nghiệp đang tìm kiếm gì trong các lĩnh vực AI, coaching, tư vấn, đào tạo trực tuyến và phát triển SME.",

      sections: [
        {
          country: "Nền Tảng Toàn Cầu",

          items: [
            {
              title: "IBISWorld Australia & New Zealand",

              description:
                "Báo cáo ngành về coaching, tư vấn, đào tạo số, giáo dục và doanh nghiệp SME.",

              link: "https://www.ibisworld.com",
            },

            {
              title: "Statista",

              description:
                "Thống kê toàn cầu và khu vực về AI, đào tạo trực tuyến, coaching và chi tiêu SME.",

              link: "https://www.statista.com",
              image: "/maria/insight/statista.png",
              embed: false,
            },

            {
              title: "LinkedIn Business Insights",

              description:
                "Xu hướng kỹ năng, tuyển dụng, nhu cầu doanh nghiệp và các vấn đề nổi bật của thị trường.",

              link: "https://business.linkedin.com",
              image: "/maria/insight/linkedin.png",
              embed: false,
            },
          ],
        },
      ],
    },
  ],
};

export const insightCTA = {
  en: {
    text: "Turn insights into strategy, growth, and measurable business impact.",
    button1: "Contact us now →",
  },

  vi: {
    text: "Biến thông tin và xu hướng thành chiến lược, tăng trưởng và kết quả kinh doanh thực tế.",
    button1: "Liên hệ ngay →",
  },
};

export const discussMaria = {
  en: {
    quote:
      "Start growing your business today. Book a Complimentary Business Health Check to explore your business potential and unlock new growth opportunities.",

    name: "Maria Pooley",

    role: "Founder | Business Advisor | Consultant | Leadership Coach",

    button1: "Enquire now",
  },

  vi: {
    quote:
      "Bắt đầu phát triển doanh nghiệp của bạn ngay hôm nay. Đặt lịch Kiểm Tra Doanh Nghiệp Miễn Phí để khám phá tiềm năng kinh doanh và mở ra những cơ hội tăng trưởng mới.",

    name: "Maria Pooley",

    role: "Nhà Sáng Lập | Cố Vấn Kinh Doanh | Chuyên Gia Tư Vấn | Coaching Lãnh Đạo",

    button1: "Liên hệ ngay",
  },
};
